import { EInvoiceAddressSchemeType } from '@components'

import { useCallback } from 'react'

import { SendAsEInvoiceForm } from '@features/invoices/types/sendAsEInvoiceForm'

import { useInvoiceEditorActions } from '../contexts/invoiceEditorActionsContext'
import { useInvoiceEditorForm } from '../contexts/invoiceEditorFormContext'

interface UpdateReceiverEInvoicingAddressFieldsAndSubmitOptions {
  formData: SendAsEInvoiceForm
}

export const useUpdateReceiverEInvoicingAddressFieldsAndSubmit = () => {
  const { submit } = useInvoiceEditorActions()
  const { invoiceEditorForm } = useInvoiceEditorForm()
  const { setValue } = invoiceEditorForm

  const updateReceiverEInvoicingAddressFieldsAndSubmit = useCallback(
    ({ formData }: UpdateReceiverEInvoicingAddressFieldsAndSubmitOptions) => {
      const { addressingLine, attachmentUuids, ean, eInvoiceScheme, publicEntityRoutingEnabled } = formData

      setValue('receiver.ean', ean)
      setValue('receiver.eInvoiceScheme', eInvoiceScheme)
      setValue('receiver.publicEntityRoutingEnabled', publicEntityRoutingEnabled)

      if (eInvoiceScheme === EInvoiceAddressSchemeType.LWID && publicEntityRoutingEnabled) {
        setValue('buyerReference', ean)
      }

      submit.sendAsEInvoice({ addressingLine, attachmentUuids })
    },
    [setValue, submit],
  )

  return { updateReceiverEInvoicingAddressFieldsAndSubmit }
}
